export default __webpack_public_path__ + "/assets/fonts/inria-serif-latin-700-normal.woff";